import { GridColDef } from "@mui/x-data-grid-pro";
import { AddGeneralCodeDialog } from "components/alove/AddGeneralCodeDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { TwoSizeChip } from "components/alove/Chips";
import { TablePage } from "components/alove/TablePage";
import { setCurrentDialog, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { BoSettingsPage } from "models/BO/BoSettingsPage";
import { useNavigate } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { getSettingsPages, publishBoSettingsPageDO } from "utils/boSettingsPageUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { GeneralCodeType } from "models/content/GeneralCode";
import { GeneralCode } from "models/content/GeneralCode";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export const BoSettingsPagesList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      headerName: "ID",
      field: "id",
      flex: 0.5,
    },
    {
      headerName: "Title",
      field: "title",
      flex: 1,
    },
    {
      headerName: "Status",
      field: "statusId",
      flex: 1,
    },
  ];

  const loadBoSettingsPages = () => getSettingsPages();

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Settings Pages" />
      <TablePage
        actions={{
          title: "Settings Pages actions",
          addActions: [
            {
              label: "Page",
              onClick: () => navigate("/boSettingsPages/new"),
              variant: "contained",
              color: "secondary",
            }
          ],
        }}
        table={{
          loadNext: loadBoSettingsPages,
          columns,
          lineClick: (boSettingsPage) => !isNaN(boSettingsPage.id) && navigate(`/boSettingsPages/${boSettingsPage.id}`),
          
        }}
        title="BoSettingsPages"
      />
      <AddGeneralCodeDialog entity={'Page'} type={GeneralCodeType.BoSettingsPage} />
    </DashboardLayout>
  );
};
